// const rootEl = document.getElementById('navbar-root');
const nextElements = document.querySelectorAll('[data-next]')
const backBtn = document.getElementById('back-btn')
const showingNestedNavElements = document.getElementsByClassName(
  'nested-nav show'
)
const mobileMenuContainer = document.getElementById(
  'mobile-mainmenu-container'
)

function mobileNavGoNext () {
  if (nextElements) {
    for (const nextElement of nextElements) {
      nextElement.addEventListener(returnDeviceSpecificClickEvent(), e => {
        e.preventDefault()
        nextElement.nextElementSibling.classList.add('show')
        nextElement.parentElement.parentElement.classList.add('child-active')
        backBtn.classList.add('show')
      })
    }
  }
}

function mobileNavBackButton () {
  if (backBtn) {
    backBtn.addEventListener(returnDeviceSpecificClickEvent(), () => {
      // Reset scroll position
      mobileMenuContainer.scrollTo(0, 0)

      // Only remove last show state (for nested items)
      if (showingNestedNavElements.length > 1) {
        showingNestedNavElements[
          showingNestedNavElements.length - 1
        ].classList.remove('show')
      } else {
        showingNestedNavElements[0].classList.remove('show')
        backBtn.classList.remove('show')
      }
    })
  }
}

/**
 * Return the device specific click event for mobile/tablet and desktop
 */
function returnDeviceSpecificClickEvent () {
  if ('touchend' in window) {
    return 'touchend'
  } else {
    return 'click'
  }
}

export { mobileNavGoNext, mobileNavBackButton }
